// extracted by mini-css-extract-plugin
module.exports = {"button_box":"PdfDownloadModal__button_box--2qye3","button_frame":"PdfDownloadModal__button_frame--1_7z6"};